import { AbstractControl, ValidatorFn } from '@angular/forms';

export function minValidator(min: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        const value = parseFloat(control.value);
        return !isNaN(value) && value < min ? { 'minValueValidation': { min: min } } : null;
    };
}